import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../../components/common/LanguageSelector';
import { getPublicPageContent } from './publicPageContent';

export const TERMS_VERSION = '003';
const BRAND_LOGO = '/logos/logo-alta-preta.png?v=20260520';

const TermsPage = () => {
  const { i18n } = useTranslation();
  const content = getPublicPageContent(i18n.language);
  const { nav, terms, footer } = content;

  useEffect(() => {
    document.title = terms.metaTitle;
  }, [terms.metaTitle]);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 antialiased">
      <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/90 backdrop-blur">
        <div className="mx-auto flex min-h-28 max-w-6xl items-center justify-between gap-3 px-5 py-3">
          <Link to="/" className="flex shrink-0 items-center" aria-label="Clarity Files">
            <img src={BRAND_LOGO} alt="Clarity Files" className="h-[72px] w-auto max-w-[165px] object-contain" />
          </Link>
          <nav className="flex items-center gap-2 text-sm font-semibold sm:gap-3">
            <Link to="/" className="rounded-xl px-4 py-2 text-slate-700 hover:bg-slate-100">
              {nav.home}
            </Link>
            <Link to="/register" className="rounded-xl bg-clarity-500 px-4 py-2 text-white hover:bg-clarity-600">
              {nav.freeTrial}
            </Link>
            <LanguageSelector showLabel={false} className="shrink-0" />
          </nav>
        </div>
      </header>

      <main>
        <section className="bg-gradient-to-b from-white to-slate-100">
          <div className="mx-auto max-w-4xl px-5 py-16 text-center">
            <span className="inline-flex rounded-full">
              <img src={BRAND_LOGO} alt="Clarity Files" className="h-[108px] w-auto max-w-full object-contain" />
            </span>
            <h1 className="mt-6 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">{terms.title}</h1>
            <p className="mx-auto mt-5 max-w-2xl text-base leading-8 text-slate-600">{terms.description}</p>
          </div>
        </section>

        <section className="mx-auto max-w-4xl px-5 py-12">
          <article className="rounded-3xl border border-slate-200 bg-white p-6 shadow-[0_12px_30px_rgba(15,23,42,.08)] md:p-10">
            <p className="rounded-2xl bg-slate-100 p-4 text-sm leading-7 text-slate-600">
              <strong>{terms.version}</strong> - {terms.updated}
            </p>

            {terms.documents.map((item) => (
              item.kind === 'title' ? (
                <h1 key={item.text} className="mt-12 text-3xl font-black tracking-tight text-slate-950">{item.text}</h1>
              ) : (
                <section key={item.title}>
                  <h2 className="mt-10 text-xl font-extrabold text-slate-950">{item.title}</h2>
                  {item.paragraphs.map((paragraph) => (
                    <p key={paragraph} className="mt-3 leading-8 text-slate-700">{paragraph}</p>
                  ))}
                </section>
              )
            ))}
          </article>
        </section>
      </main>

      <footer className="border-t border-slate-200 bg-white py-8">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-5 text-xs text-slate-500 md:flex-row">
          <img src={BRAND_LOGO} alt="Clarity Files" className="h-16 w-auto max-w-[142px] object-contain" />
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <a href={`mailto:${footer.contact}`} className="hover:text-clarity-600">{footer.contact}</a>
          </div>
          <p>{footer.copyright}</p>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
